import { ItfKspSwiperData, ItfKspSwiperItem, ItfKspSwiperItemModal, ItfKspSwiperItemModalItem, ItfKspSwiperTab } from './type';

export const detaultItemModalItem: ItfKspSwiperItemModalItem = {
    name: '',
    text: '',
    pc: '',
    h5: '',
};

export const detaultItemModal: ItfKspSwiperItemModal = {
    name: '',
    text: '',
    items: [detaultItemModalItem],
};

export const defaultItem: ItfKspSwiperItem = {
    name: '',
    text: '',
    textColor: '#83868A',
    pc: '',
    h5: '',
    isModal: false,
    modal: detaultItemModal,
};

export const defaultTab: ItfKspSwiperTab = {
    name: '',
    items: [JSON.parse(JSON.stringify(defaultItem))],
};

export const configData: ItfKspSwiperData = {
    theme: 'white',
    title: '',
    titleColor: 'black',
    tabs: [JSON.parse(JSON.stringify(defaultTab))],
};

/** 将仅含顶层 items 的旧数据转为 tabs 结构 */
export function normalizeKspSwiperData(d: unknown): ItfKspSwiperData {
    const raw = d && typeof d === 'object' && Object.keys(d as object).length > 0 ? (d as ItfKspSwiperData) : configData;
    const tabs = raw.tabs;
    if (Array.isArray(tabs) && tabs.length > 0 && tabs.every((t) => t && Array.isArray(t.items))) {
        return { ...configData, ...raw, tabs };
    }
    const legacyItems = raw.items;
    const items = Array.isArray(legacyItems) && legacyItems.length > 0 ? legacyItems : [JSON.parse(JSON.stringify(defaultItem))];
    return {
        ...configData,
        ...raw,
        tabs: [{ name: '', items }],
    };
}
